import React, { Component, HTMLAttributes } from 'react';
import { FormFieldProps, FormFieldBoolean } from '../../commonTypes/formField.types';
import { hashCode } from '../../utils/hash';
import { InputError } from 'sos-common/js/components/InputError/InputError';

export interface CheckBoxProps extends FormFieldProps<boolean> {
  stringValue?: string | number;
  onChangeCallback?: (state: CheckBoxState) => void;
}

export interface CheckBoxState extends FormFieldBoolean {
  stringValue: string | number;
}
const DEFAULT_STATE_VALUE = false;
export class CheckBox extends Component<CheckBoxProps, CheckBoxState> {
  private _errorId: string;

  static defaultProps = {
    fieldName: '',
    value: false,
    isRequired: false,
    isTouched: false,
    errorMessage: '',
    label: '',
    stringValue: '',
    onChange: () => {
      /* noop */
    },
    onChangeCallback: () => {},
    onBlur: () => {},
  } as CheckBoxProps;

  private _id: string;
  private _latestValue: boolean | string | undefined;

  constructor(props: CheckBoxProps) {
    super(props);
    this._id = props.id || hashCode(props.fieldName, 'CheckBox');
    this._errorId = hashCode(props.id || props.fieldName, 'error');

    const { fieldName, value, isRequired, label, stringValue } = props;

    if (props.value !== undefined) {
      this._latestValue = value;
    } else {
      this._latestValue = DEFAULT_STATE_VALUE;
    }

    this.state = {
      value: this._latestValue,
      fieldName,
      isRequired,
      isTouched: false,
      label,
      stringValue,
      errorMessage: '',
    };
  }

  private get _ariaAttributes(): HTMLAttributes<any> {
    const { errorAriaAttributes, ariaLabel, ariaDescribedBy } = this.props;
    if (errorAriaAttributes) return errorAriaAttributes;
    if (this._errorMessage) return { 'aria-invalid': true, 'aria-describedby': this._errorId };

    if (ariaLabel && ariaDescribedBy && ariaLabel.length > 0 && ariaDescribedBy.length > 0)
      return { 'aria-label': ariaLabel, 'aria-describedby': ariaDescribedBy };
    if (ariaLabel && ariaLabel.length > 0) return { 'aria-label': ariaLabel };
    if (ariaDescribedBy && ariaDescribedBy.length > 0) return { 'aria-describedby': ariaDescribedBy };

    return {};
  }

  public render() {
    const { fieldName, isRequired, label, disabled, autoComplete, stringValue } = this.props;
    const formValue = this.state.value;
    const errorMessage = this._errorMessage;
    const validityClass = !errorMessage ? 'is-valid' : 'is-invalid';

    return (
      <div className="form-group-xs-small" {...this.props.attributes}>
        <label className={`radio-checkbox-label ${disabled ? 'disabled-input' : ''}`} htmlFor={this._id}>
          <input
            type="checkbox"
            id={this._id}
            onFocus={this.onFocus}
            name={fieldName}
            checked={formValue}
            value={stringValue}
            onChange={this.onChangeValue}
            required={isRequired}
            className={`form-control ${validityClass}`}
            disabled={disabled}
            autoComplete={autoComplete}
            {...this._ariaAttributes}
          />{' '}
          {label}
        </label>
        {errorMessage && <InputError id={this._errorId} errorText={errorMessage} />}
      </div>
    );
  }

  private get _errorMessage(): string | undefined {
    let { errorMessage } = this.state;
    if (!errorMessage && this.props.errorMessage) {
      errorMessage = this.props.errorMessage;
    }

    return errorMessage;
  }

  private onChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    var value = e.target.checked;
    if (value != this.state.value) {
      this.setState(
        () => ({
          value,
        }),
        () => {
          this.props.onChange(this.state);
          this.props.onChangeCallback(this.state);
        },
      );
    }
  };

  private onFocus = (e: React.FocusEvent) => {
    this.setState(
      {
        isTouched: true,
      },
      () => {
        this.props.onBlur(e);
      },
    );
  };
}
